<template>
  <div id="memo">
    <el-form label-position="left" class="m-4 text-left">
      <el-form-item  label-width="25%" size="mini">
        <template slot="label">
          <i class="fa fa-fw fa-commenting-o"></i>
          描述
        </template>
        <el-input v-model="data.Memo" style="width:100%"></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "memo",
  data() {
    return {};
  },
  props: {
    data: Object
  },
  methods: {},
  created() {}
};
</script>

<style scoped>
</style>